import { IMapresource } from "../models/Mapresource";

const getNumberAttribute = (el: any, attr: string) => parseInt(el.getAttribute(attr));

/**
 * Parser for handling standard map resource file
 * @param xmlData 
 */
export const parseMapresourceXML = (xmlData: string): IMapresource => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlData, "text/xml");
    const tileFormatEl = xmlDoc.getElementsByTagName("TileFormat")[0]
    const tileSetsEl = xmlDoc.getElementsByTagName("TileSets")[0]

    let layersElList: any = tileSetsEl.childNodes
    layersElList = [].filter.call(layersElList, (el: any) => el.tagName === 'TileSet')

    const layerList = [].map.call(layersElList, (el: any): IMapresource["tileSet"]["layers"][any] => {
        return {
            href: el?.getAttribute ? el?.getAttribute("href") : undefined,
            order: el?.getAttribute ? el?.getAttribute("order") : undefined,
            unitsPerPixel: el?.getAttribute ? el?.getAttribute("units-per-pixel") : undefined
        }
    })

    const originEl = xmlDoc.getElementsByTagName("Origin")[0]
    const boundingBoxEl = xmlDoc.getElementsByTagName("BoundingBox")[0]

    return {
        tileFormat: {
            extension: tileFormatEl.getAttribute('extension') || "png",
            width: getNumberAttribute(tileFormatEl, "width"),
            height: getNumberAttribute(tileFormatEl, "height"),
        },
        tileSet: {
            profile: tileSetsEl.getAttribute('profile') || "raster",
            layers: layerList as IMapresource["tileSet"]["layers"]
        },
        origin: {
            x: originEl && getNumberAttribute(originEl, "x"),
            y: originEl && getNumberAttribute(originEl, 'y'),
        },
        boundingBox: {
            minY: boundingBoxEl && getNumberAttribute(boundingBoxEl, "miny"),
            maxY: boundingBoxEl && getNumberAttribute(boundingBoxEl, 'maxy'),
            maxX: boundingBoxEl && getNumberAttribute(boundingBoxEl, 'maxx'),
            minX: boundingBoxEl && getNumberAttribute(boundingBoxEl, 'minx')
        }
    }
}